<template>
    <div class="layout-container table-special">
        <el-tabs type="border-card">
            <el-tab-pane label="资讯内容项列表">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="'show'">
                        <div class="search-condition">
                            <span class="label" >类型</span>
                            <div class="input-condition" >
                                <el-select v-model="condition.type" placeholder="全部">
                                    <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                                </el-select>
                            </div>
                        </div>
                         <div class="search-condition">
                            <span class="label" >内容项</span>
                            <div class="input-condition" >
                                <el-select v-model="condition.body_type" placeholder="全部">
                                    <el-option v-for="item in bodyType" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time" style="min-width: 400px;">
                            <span class="label">添加时间</span>
                            <div class="input-condition">
                                <el-date-picker
                                        v-model="condition.time"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        align="right"
                                        value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                                        @change="condition.timestamp = ''"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                        <el-button
                        type="primary"
                        icon="el-icon-plus"
                        @click="handleAdd()"
                        v-permission="'operating.news-model-manage.content-list.create'"
                        >新增内容项</el-button>
                    </div>
                </div>
               
            <el-table
                    :data="list"
                    style="width: 100%"
                    :highlight-current-row="true"
                    stripe
                    tooltip-effect="dark"
                    ref="multipleTable"
                    v-loading="isLoading"
                    header-cell-class-name="table-back"
                    class="list-table"
            >
                <el-table-column  label="ID" prop="id"  width="60px" align="center"></el-table-column>
                <el-table-column  label="类型" prop="type_name" align="center"></el-table-column>
                <el-table-column  label="内容项" prop="body_type_name"  align="center"></el-table-column>
                <el-table-column  label="内容" prop="body"  align="center">
                    <template slot-scope="scope">
                        <p class="ellips2" :title="scope.row.body">{{scope.row.body}}</p>
                    </template>
                </el-table-column>
                <el-table-column  label="添加人" prop="creator"  align="center"></el-table-column>
                <el-table-column  label="添加时间" prop="created_at"  align="center"></el-table-column>
                <el-table-column label="操作"   width="300px" align="center">
                    <template slot-scope="scope">
                        <el-button v-permission="'operating.news-model-manage.content-list.edit'" size="mini" @click="openEdit(scope.row)"
                            >编辑</el-button>
                        <el-button v-permission="'operating.news-model-manage.content-list.delete'" size="mini" @click="handleDelete(scope.row.id)"
                            >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
             <template v-if="list.length > 0">
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    :current-page="condition.page"
                    :total="condition.total"
                    :page-size="condition.per_page"
                    @current-change="currentChange"
                ></el-pagination>
            </template>
        </el-tab-pane>
    </el-tabs>
    <add-content ref="contentAddRef" :callback="initData"  @showTagLib="showTagLib"/>
    <edit-content ref="contentEditRef" :callback="initData"  @showTagLib="showTagLib" />
    <tag-lib ref="tagLib"></tag-lib>
    </div>
</template>
<style>
    td a:link{
        color: #606266;
    }
    td a:visited{
        color: #606266;
    }
</style>
<script>
    import {getCntListByPage,deleteNewsCnt} from '@/service/newsModel'
    import { NEWS_MODEL } from "@/config/index";
    import addContent from './component/add';
    import editContent from './component/edit';
    import TagLib from './component/tagLib';
    export default {
        components: { addContent ,editContent,TagLib},

        name: "List",
        data () {
            return {
                typeList:[],
                bodyType:[],
                list: [],
                condition: {
                    type: '',
                    body_type:'',
                    time:'',
                    total: 0,
                    per_page: 10,
                    page: 1,
                },
                isLoading: false,
               
            }
        },
        mounted () {
            this.typeList = NEWS_MODEL.news_types;
            this.bodyType = NEWS_MODEL.body_type;
            this.initData()
        },
        methods: {

            handleSearch() {
                this.condition.page=1
                this.initData();
            },
            resetSearch() {
                this.condition = {
                    type_id: '',
                    name:'',
                    time:'',
                    total: 0,
                    per_page: 10,
                    page: 1,
                }
                this.initData();
            },
            handleAdd() {
                this.$refs.contentAddRef && this.$refs.contentAddRef.openMenu()

            },
           openEdit(item){
                this.$refs.contentEditRef && this.$refs.contentEditRef.openMenu(item.id)
           },
           showTagLib(){
                this.$refs.tagLib.openMenu()
            },
            currentChange(index) {
                this.condition.page = index;
                this.initData();
            },
            async initData() {
                this.list=[]
                if(this.condition.time && this.condition.time.length>1) {
                    this.condition.created_time_start= new Date(this.condition.time[0]).getTime()/1000
                    this.condition.created_time_end = new Date(this.condition.time[1]).getTime()/1000
                }else{
                    delete this.condition.created_time_start;
                    delete this.condition.created_time_end;
                }
                await getCntListByPage(this.condition).then((data) => {
                    this.condition.total=data.total
                    this.list = data.data
                })
                this.isLoading = false
            },
           handleDelete(id) {
                this.$confirm("请确认是否删除该内容项？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    deleteNewsCnt(id)
                    .then(() => {
                        this.$message({
                        type: "success",
                        message: "删除成功"
                        });
                        this.initData();
                    })
                    .catch(err => {
                        this.$message({
                        type: "error",
                        message: err.message || "删除失败"
                        });
                    });
                });
            },
            createNews(id){

            },
            goScan(id){

            },
            getRecord(id){

            },
        }
    }
</script>

<style scoped>
.list-table {
    padding: 0 20px;
    box-sizing: border-box;
}
.baikeCat .el-select{
    width:48%;
    float:left;
}
.ellips2{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
</style>



















